// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { TaskEffects } from './store/effects';
import * as fromTask from './store/reducer';

// SERVICES
import { TaskService } from './services/task.service';
import { TaskStoreService } from './task-store.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['task'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure task ngrx related stuff.
 *
 *   @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 * Notes:-
 * Date: 19/05/-2020 Task store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('Task', fromTask.reducer, { metaReducers }),
    EffectsModule.forFeature([TaskEffects]),
  ],
  declarations: [],
  providers: [
    TaskService,
    TaskStoreService,
  ],
})
export class TaskStoreModule { }
